const CheckCircle = () => {
    return <svg xmlns="http://www.w3.org/2000/svg" width="66" height="66" viewBox="0 0 66 66" fill="none">
        <rect x="5" y="5" width="56" height="56" rx="28" fill="#D1FADF"/>
        <rect x="5" y="5" width="56" height="56" rx="28" stroke="#ECFDF3" stroke-width="10"/>
        <path
            d="M44.6668 31.9267V33C44.6654 35.5158 43.8507 37.9638 42.3444 39.9788C40.838 41.9938 38.7207 43.4679 36.3081 44.1812C33.8955 44.8945 31.317 44.8089 28.957 43.937C26.5971 43.0652 24.5823 41.4538 23.2129 39.3433C21.8436 37.2327 21.1933 34.7361 21.3588 32.2257C21.5243 29.7153 22.4969 27.3257 24.1315 25.4133C25.7661 23.5008 27.9751 22.168 30.429 21.6135C32.883 21.0591 35.4505 21.3127 37.7485 22.3367M44.6668 23.6667L33.0002 35.345L29.5002 31.845"
            stroke="#039855" stroke-width="2.33333" stroke-linecap="round" stroke-linejoin="round"/>
    </svg>
}

export default CheckCircle;